import { BenefitTypeIcon, BenefitTypeIconGlyph } from "./benefit-type-icon";
export var ImpactResultTypeIcon = BenefitTypeIcon;
export var ImpactResultTypeIconGlyph = BenefitTypeIconGlyph;